export const isAbleToStartBreak = (
  pauseStartedAt: string | null,
  pauseEndedAt: string | null,
): boolean => {
  if ((!pauseStartedAt && !pauseEndedAt) || (pauseStartedAt && pauseEndedAt)) return true;
  return false;
};
